import type { UserStoreUser } from '../context/AuthContext';

const OCIF_ORGANIZATIONAL_UNIT_NAME = 'OCIF';

// Matched by name rather than id since organizational unit ids can vary across environments.
export function isOcifOrganizationalUnit(user: UserStoreUser | null | undefined): boolean {
  return user?.user?.organizationalUnit?.name === OCIF_ORGANIZATIONAL_UNIT_NAME;
}

// user.user.organizationalUnit only reflects the user's home org; a user "working as" a
// different org (see AuthContextValue.setOrganizationalUnit) only updates actualOrganizationalUnitId,
// so the tenant must be looked up from organizationalUnitRoles to stay in sync with that switch.
export function getActiveOrganizationalUnitTenantId(user: UserStoreUser | null | undefined): number | undefined {
  const activeOrganizationalUnitId = user?.user?.actualOrganizationalUnitId ?? user?.user?.organizationalUnit?.id;

  return (
    user?.organizationalUnitRoles?.find(role => role.organizationalUnitId === activeOrganizationalUnitId)?.organizationalUnit?.tenantId ??
    user?.user?.organizationalUnit?.tenantId
  );
}
